/** Biological-gender answer values, grouped by icon/branch — matched case-insensitively, value-string based (no question IDs). */
export const GENDER_VALUES = {
  male: ["male", "männlich", "homme"],
  female: ["female", "weiblich", "femme"],
} as const;

/** Words highlighted orange in answer option text (e.g. "A weekly injection" vs "A daily injection"). */
export const HIGHLIGHT_WORDS = ["weekly", "daily", "woche", "tag"] as const;

export const GOAL_WEIGHT_FACTOR = 0.85;

/** Timeframes offered on the weight projection interstitial (HL-11982). */
export const PROJECTION_MONTHS = [3, 6, 12] as const;
export type ProjectionMonths = (typeof PROJECTION_MONTHS)[number];

/** Figma sample 115 kg -> 106 / 98 / 84 kg. 6 months is the existing goal factor. */
export const PROJECTION_FACTORS: Record<ProjectionMonths, number> = {
  3: 0.92,
  6: GOAL_WEIGHT_FACTOR,
  12: 0.73,
};

export function projectedWeightAt(weightKg: number, months: ProjectionMonths): number {
  return Math.round(weightKg * PROJECTION_FACTORS[months]);
}

export function projectedGoalWeight(weightKg: number): number {
  return projectedWeightAt(weightKg, 6);
}
